import React from 'react';
import { Route } from 'react-router-dom';

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props => (
            <Component {...rest} {...props}>
                {props.children}
            </Component>
        )}
    />
);

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js